export default __webpack_public_path__ + "static/media/contact.5fac45a5.svg";